import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import '../../App.css';


function BlogAdminLogin({ setIsAdmin }) {
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL ;
  const handleLogin = (e) => {
    e.preventDefault();
    fetch('${apiUrl}/blog/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ password })
    })
      .then(res => {
        if (res.ok) return res.json();
        throw new Error('Incorrect password');
      })
      .then(() => {
        setIsAdmin(true);
        navigate('/admin');
      })
      .catch(() => {
        setErrorMessage('Incorrect password. Please try again.');
      });
  };

  return (
    <div className="blog-admin-login-container">
      <h1>Super Admin Login</h1>
      <form onSubmit={handleLogin} className="blog-admin-login-form">
        <input
          type="password"
          placeholder="Enter Super Admin Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" className="blog-btn">Login</button>
        {errorMessage && <p className="blog-error-message">{errorMessage}</p>}
      </form>
    </div>
  );
}
export default BlogAdminLogin;
